export default {
  path: '/section_parameters',
  name: 'section_parameters',
  component: () => import('../components/sectionparameter/Layout'),
  redirect: { name: 'SectionParameterList' },
  meta: {
    breadcrumb: 'profile.sectionparameter.sectionparameters',
  },
  children: [
    {
      name: 'SectionParameterList',
      path: '',
      component: () => import('../views/sectionparameter/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'SectionParameterCreate',
      path: 'new',
      component: () => import('../views/sectionparameter/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'SectionParameterUpdate',
      path: ':id/edit',
      component: () => import('../views/sectionparameter/Update'),
      meta: {
        breadcrumb: 'profile.sectionparameter.sectionparameter',
      },
    },
    {
      name: 'SectionParameterShow',
      path: ':id',
      component: () => import('../views/sectionparameter/Show'),
      meta: {
        breadcrumb: 'profile.sectionparameter.sectionparameter',
      },
    }
  ]
};
